export default class Custodian {
  constructor() {
    this.custodianTypes = [];
    this.orderedCustodianTypes = [];
    this.states = [];
    this.relationships = [];
    this.custodianPerformanceDateMap = null;
  }
}
